import React from "react";
import moment from "moment-timezone";
import { Constants } from "@eagerdog/constants";
import AkcObedienceAwards from "../../../components/ShowAwardsModal/AkcObedienceAwards/AkcObedienceAwards";
import AkcRallyObedienceAwards from "../../../components/ShowAwardsModal/AkcRallyObedienceAwards/AkcRallyObedienceAwards";
import AkcScentworkAwards from "../../../components/ShowAwardsModal/AkcScentworkAwards/AkcScentworkAwards";
import UkcObedienceAwards from "../../../components/ShowAwardsModal/UkcObedienceAwards/UkcObedienceAwards";
import UkcRallyObedienceAwards from "../../../components/ShowAwardsModal/UkcRallyObedienceAwards/UkcRallyObedienceAwards";
import UkcAgilityAwards from "../../../components/ShowAwardsModal/UkcAgilityAwards/UkcAgilityAwards";
import styles from "./ShowAwardsSection.module.scss";

interface IProps {
  event: any;
  shows: any[];
  scores: any[];
}

const ShowAwardsSection: React.FC<IProps> = ({ event, shows, scores }) => {
  const formatShowHeader = (show: any) => {
    const timezone = event.timezone || moment.tz.guess();
    const showDate = moment(show.show_date).tz(timezone).format("MMMM D, YYYY");
    
    // Format show type
    const showType = (Constants.show_type as any)[show.show_type] || show.show_type;
    const showName = show.show_name;
    
    return `${showType} ${showName} - ${showDate}`;
  };

  const getAwardsComponent = (show: any) => {
    if (event.sanctioning_club === Constants.sanctioning_club.AKC) {
      if (show.show_type === Constants.show_type.obedience) {
        return <AkcObedienceAwards event={event} show={show} scores={scores} />;
      }
      if (show.show_type === Constants.show_type.rally_obedience) {
        return <AkcRallyObedienceAwards event={event} show={show} scores={scores} />;
      }
      if (show.show_type === Constants.show_type.scentwork) {
        return <AkcScentworkAwards event={event} show={show} scores={scores} />;
      }
    }

    if (event.sanctioning_club === Constants.sanctioning_club.UKC) {
      if (show.show_type === Constants.show_type.obedience) {
        return <UkcObedienceAwards event={event} show={show} scores={scores} />;
      }
      if (show.show_type === Constants.show_type.rally_obedience) {
        return <UkcRallyObedienceAwards event={event} show={show} scores={scores} />;
      }
      if (show.show_type === Constants.show_type.agility) {
        return <UkcAgilityAwards event={event} show={show} scores={scores} />;
      }
    }

    return (
      <div className={styles.noAwards}>
        Awards are not available for this show type yet.
      </div>
    );
  };

  return (
    <div className={styles.ShowAwardsSection}>
      <div className={styles.header}>
        <h2 className={styles.sectionTitle}>Show Awards</h2>
      </div>
      
      <div className={styles.content}>
        {shows.map((show, index) => (
          <div key={show._id || index} className={styles.showAwards}>
            <div className={styles.showHeader}>
              {formatShowHeader(show)}
            </div>
            
            <div className={styles.awardsContainer}>
              {getAwardsComponent(show)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShowAwardsSection;

